import { SelectRadio } from '@/components/select-radio/SelectRadio';
import type { HttpApiServerType } from '@/services/http-api/httpApi';
import { defaultSampleCodeVariant } from '@/shared/util/generateRequestSampleCode';
import type { Example } from '@tarslib/types/lib/httpApi';
import React from 'react';

export type RequestSampleCodeVariantsProps = {
  variants: HttpApiServerType['codeSampleLanguages'][number]['variants'] | undefined;
  value: string | undefined;

  selectedRequestExampleKey: string | undefined;
  onSelectedRequestExampleKey: (key: string) => void;
  requestExamples: (Example & {
    key: string;
  })[];

  onChange: (value: string) => void;
};

export function RequestSampleCodeVariants(props: RequestSampleCodeVariantsProps) {
  const {
    requestExamples,
    variants,
    value = defaultSampleCodeVariant,
    onChange,
    selectedRequestExampleKey,
    onSelectedRequestExampleKey,
  } = props;

  const options = React.useMemo(() => {
    return (
      variants?.map((variant) => ({
        label: variant.name ?? variant.key,
        value: variant.key,
      })) ?? []
    );
  }, [variants]);

  const requestExamplesOptions = React.useMemo(() => {
    return requestExamples.map((x) => {
      return {
        label: x.name,
        value: x.key,
      };
    });
  }, [requestExamples]);

  if (options.length < 2 && requestExamplesOptions.length < 2) {
    return null;
  }
  return (
    <div className="mx-4 overflow-x-auto py-2">
      <SelectRadio
        type="radio"
        options={requestExamplesOptions}
        minShowItemCount={1}
        value={selectedRequestExampleKey}
        onChange={onSelectedRequestExampleKey}
        theme="dark"
        prefixNode={
          <SelectRadio
            type={requestExamplesOptions.length > 1 ? 'select' : 'radio'}
            options={options}
            minShowItemCount={1}
            value={value}
            onChange={onChange}
            theme="dark"
          />
        }
      />
    </div>
  );
}
